export default {
  root: {
    borderRadius: 3,
    overflow: "hidden"
  },
  colorPrimary: {
    backgroundColor: "#3c1a5b"
  }
};
